<template>
  <section>
    <Feature :title="$t('CCL_MASTER_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow
        :fieldNameArr="[$t('CCL_SUPPLIER'), $t('CCL_LAMINATE_TYPE'), $t('CORE_UL_NUMBER'), $t('VALID_FROM'), $t('VALID_TO'), $t('LOG')]">
        <Select style="width: 200px" v-model="cclSupplierName" @on-change="changeCclSupplier($event)"
          :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in cclSuppliers" :value="item.vendorName" :key="item.id">
            {{ item.vendorCode }}
          </Option>
        </Select>
        <Select style="width: 200px" v-model="cclLaminateType" :placeholder="$t('CHOOSE')" slot="b">
          <Option v-for="(item) in cclLaminateTypes" :value="item" :key="item">
            {{ item }}
          </Option>
        </Select>
        <Select style="width: 200px" v-model="coreUlNumberPartNoDesc" @on-change="chagneCoreUlNumber($event)"
          :placeholder="$t('CHOOSE')" slot="c">
          <Option v-for="(item) in coreUlNumbers" :value="item.partNoDesc" :key="item.id">
            {{ item.partNoDesc }}
          </Option>
        </Select>
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="d">
        </DatePicker>
        <DatePicker v-model="validTo" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="e"></DatePicker>
        <i-switch v-model="isLog" slot="f"></i-switch>
      </FormRow>
      <ButtonRow>
        <Button type="primary" @click="search" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="clear" slot="2">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <Feature v-show="existedPriceList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
        <Button type="primary" @click="download">{{ $t('DOWNLOAD') }}</Button>
        <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="priceList" :pageObj="pageObj"
          @changePage="changePage"></TablePage>
      </Feature>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky
      :draggable="true" v-model="model" :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, ExceptionHandling, DateToString } from "@/util/common"

export default {
  name: "CclMasterMaintain",
  created() {
    const vueInstance = this
    vueInstance.$getReferenceData(vueInstance, "/cclMaster/find/cclSupplier").then(data => {
      vueInstance.cclSuppliers = data.sort(function (a, b) {
        return a.vendorName.localeCompare(b.vendorName, "en");
      });
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
    vueInstance.$getReferenceData(vueInstance, "/cclMaster/find/corUlNumber").then(data => {
      vueInstance.coreUlNumbers = data.sort(function (a, b) {
        return a.partNoDesc.localeCompare(b.partNoDesc, "en");
      });
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
    vueInstance.$getReferenceData(vueInstance, "/cclMaster/find/cclLaminateType").then(data => {
      vueInstance.cclLaminateTypes = data.sort(function (a, b) {
        return a.localeCompare(b, "en");
      });
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
  },
  data() {
    return {
      model: false,
      validFrom: null,
      validTo: null,
      isLog: false,
      file: null,
      cclSupplierName: '',
      cclSupplier: {},
      cclSuppliers: [],
      cclLaminateType: '',
      cclLaminateTypes: [],
      coreUlNumberPartNoDesc: '',
      coreUlNumber: {},
      coreUlNumbers: [],
      priceList: [],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('CCL_SUPPLIER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "cclSupplierCode",
          width: 120,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CCL_SUPPLIER_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "cclSupplierName",
          width: 120,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CORE_UL_NUMBER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "coreUlPartNo",
          width: 120,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "coreUlPartNoDesc",
          width: 120,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CCL_LAMINATE_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "cclLaminateType",
          width: 120,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('INTERNAL_CORE_THICKNESS') + "(mm)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "internalCoreThickness",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('EXTERNAL_COPPER_THICKNESS') + "(oz)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "externalCopperThickness",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('INTERNAL_COPPER_THICKNESS') + "(oz)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "internalCopperThickness",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "tg",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "currency",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CCL_UP')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "coreUp",
          width: 80,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validFrom",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validTo",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_GROUP_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "createGroupAccount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "created",
          sortable: true
        },
        {
          title: this.$t('ENABLED'),
          width: 60,
          align: "center",
          render: (h, params) => {
            let value = params.row["enabled"] ? "YES" : "NO"
            return h("span", {}, value)
          },
          width: 110
        }
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post('/cclMaster/search?sort=cclSupplier&sort=coreUlNumber&sort=cclLaminateType&sort=currency&sort=validFrom&page='
          + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCriteria(vueInstance)))
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.priceList = []
          if (response.data._embedded != undefined) {
            let data = response.data
            vueInstance.priceList = data._embedded.cclMasterResourceList
            vueInstance.pageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch(() => { })
    },
    changeCclSupplier(value) {
      this.cclSupplier = this.cclSuppliers.find(function (cclSupplier) {
        return cclSupplier.vendorName == value
      });
    },
    chagneCoreUlNumber(value) {
      console.log(value)
      this.coreUlNumber = this.coreUlNumbers.find(function (coreUlNumber) {
        return coreUlNumber.partNoDesc == value
      });
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'CCLMasterDataMaintain')
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$quotationHttp
        .post("/cclMaster/uploadExcel", fd)
        .then((response) => {
          console.log(response)
          this.file = null
          this.model = false
          this.search(true)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    clear() {
      const vueInstance = this
      vueInstance.validFrom = null
      vueInstance.validTo = null
      vueInstance.cclSupplierName = ''
      vueInstance.cclSupplier = {}
      vueInstance.cclLaminateType = ''
      vueInstance.coreUlNumber = {}
      vueInstance.coreUlNumberPartNoDesc = ''
    },
    download() {
      this.$downloadExcel(this, "cclMaster", buildCriteria(this), "?sort=cclSupplier&sort=coreUlNumber&sort=cclLaminateType&sort=currency&sort=validFrom")
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    existedPriceList() {
      return this.priceList && this.priceList.length > 0
    }
  }
}

function buildCriteria(vueInstance) {
  return {
    "cclSupplierId": JSON.stringify(vueInstance.cclSupplier) != '{}' && vueInstance.cclSupplier != null ? vueInstance.cclSupplier.uuid : null,
    "coreUlNumberId": JSON.stringify(vueInstance.coreUlNumber) != '{}' && vueInstance.coreUlNumber != null ? vueInstance.coreUlNumber.uuid : null,
    "cclLaminateType": vueInstance.cclLaminateType != "" ? vueInstance.cclLaminateType : null,
    "validFrom": vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    "validTo": vueInstance.validTo != "" && vueInstance.validTo != null ? DateToString(vueInstance.validTo, "-") : null,
    "enabled": !vueInstance.isLog
  }
}
</script>

<style scoped></style>
